export default __webpack_public_path__ + "static/media/hari1.024f30c4.png";